import { render, staticRenderFns } from "./LogoLight.vue?vue&type=template&id=3a5c1578"
import script from "./LogoLight.vue?vue&type=script&lang=js"
export * from "./LogoLight.vue?vue&type=script&lang=js"
import style0 from "./LogoLight.vue?vue&type=style&index=0&id=3a5c1578&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports